<template>
    <div class="w-full h-full flex flex-col p-6 lg:p-10 bg-gray-100">
        <Loading v-show="loading" :loading="loading" />
        <div class="w-full h-full">
            <div class="w-full flex flex-row justify-between items-start mb-4">
                <div class="flex-1">
                    <h1 class="text-2xl lg:text-3xl font-semibold mb-2 lg:mb-4 text-center lg:text-left" :class="{
                        'text-theme-primary': currentStep === 0,
                        'text-dark-blue': currentStep === 1,
                        'text-light-blue': currentStep === 2
                    }">{{ categoryName }}</h1>
                    <div class="flex flex-wrap lg:justify-start justify-center items-center gap-2 w-full">
                        <!-- Board of Directors Counters -->
                        <template v-if="currentStep === 0">
                            <p class="px-2 py-1 lg:px-3 lg:py-2 rounded-full text-white text-xs lg:text-sm font-medium items-center text-center shadow-md bg-theme-primary"
                                :class="{ 'opacity-50': bodOfficerCount < 3 }">{{ bodOfficerCount }}/3 - Officer</p>
                            <p class="px-2 py-1 lg:px-3 lg:py-2 rounded-full text-white text-xs lg:text-sm font-medium items-center text-center shadow-md bg-theme-primary"
                                :class="{ 'opacity-50': bodEpCount < 3 }">{{ bodEpCount }}/3 - Enlisted Personnel</p>
                            <p class="px-2 py-1 lg:px-3 lg:py-2 rounded-full text-white text-xs lg:text-sm font-medium items-center text-center shadow-md bg-theme-primary"
                                :class="{ 'opacity-50': bodCivilianCount < 2 }">{{ bodCivilianCount }}/2 - Civilian</p>
                        </template>
                        <!-- Audit Comm Counters -->
                        <template v-else-if="currentStep === 1">
                            <p class="px-2 py-1 lg:px-3 lg:py-2 rounded-full text-white text-xs lg:text-sm font-medium items-center text-center shadow-md bg-dark-blue"
                                :class="{ 'opacity-50': auditCount < 2 }">{{ auditCount }}/2</p>
                        </template>
                        <!-- Election Comm Counters -->
                        <template v-else-if="currentStep === 2">
                            <p class="px-2 py-1 lg:px-3 lg:py-2 rounded-full text-white text-xs lg:text-sm font-medium items-center text-center shadow-md bg-light-blue"
                                :class="{ 'opacity-50': elecCommCount < 1 }">{{ elecCommCount }}/1 - Civilian</p>
                        </template>
                    </div>
                </div>

                <div class="hidden lg:block w-10 h-10 p-2 rounded-full hover:opacity-75 cursor-pointer"
                    @click="showBallot" :class="{
                        'bg-theme-primary': currentStep === 0,
                        'bg-dark-blue': currentStep === 1,
                        'bg-light-blue': currentStep === 2
                    }">
                    <img src="@/assets/images/papsi_ballot.svg" class="w-full" />
                </div>

                <div v-if="!ballot_modal"
                    class="block lg:hidden fixed w-12 h-12 p-2 rounded-full hover:opacity-75 cursor-pointer bottom-4 right-4 z-[99999]"
                    @click="ballot_modal = true" :class="{
                        'bg-theme-primary': currentStep === 0,
                        'bg-dark-blue': currentStep === 1,
                        'bg-light-blue': currentStep === 2
                    }">
                    <img src="@/assets/images/papsi_ballot.svg" class="w-full" />
                </div>
            </div>

            <div class="bg-white rounded-2xl shadow-sm p-4 lg:p-7 w-full flex flex-col ">
                <!-- Step Components -->
                <div class="h-[53vh] lg:h-full">
                    <BoardOfDirectorsView v-if="currentStep === 0" @completed="stepCompleted[0] = $event" />
                    <AuditCommView v-if="currentStep === 1" @completed="stepCompleted[1] = $event" />
                    <ElectionCommView v-if="currentStep === 2" @completed="stepCompleted[2] = $event" />
                </div>

                <!-- Pagination Controls -->
                <div class="flex justify-end mt-4 w-full lg:w-[20rem] gap-4 self-end">
                    <ButtonControl v-show="currentStep === 0"
                        theme="bg-white border-2 border-theme-primary text-theme-primary" rounded
                        @click="cancel_modal = true" button_text="CANCEL" />
                    <ButtonControl v-show="currentStep != 0"
                        theme="bg-white border-2 border-theme-primary text-theme-primary" rounded @click="prevStep"
                        button_text="PREVIOUS" />
                    <ButtonControl v-if="!isLastStep" theme="bg-theme-primary" rounded
                        :disabled="!stepCompleted[currentStep]" @click="nextStep" button_text="NEXT" />
                    <ButtonControl v-else theme="bg-theme-primary" rounded :disabled="!isVotingComplete"
                        @click="showBallot()" button_text="SUBMIT" />
                </div>

            </div>


        </div>
    </div>


    <ModalControl v-show="show_message_modal" v-bind:display="show_message_modal" :error="this.error"
        :success="this.success" :note="this.warning" :question="this.question" z_value="z-50"
        @positiveClick="handlePositiveClick" @negativeClick="show_message_modal = false" :positiveButton="'OK'"
        :negativeButton="negativeBtn" :default_width="'max-w-xl'" id='vote_modal'>
        <div class="w-full px-5 pb-4 flex flex-col text-xl justify-center text-center items-center">
            {{ this.modal_message }}
        </div>
    </ModalControl>

    <ModalControl v-show="confirm_modal" v-bind:display="confirm_modal" question z_value="z-50"
        @positiveClick="submitVote" @negativeClick="confirm_modal = false" :positiveButton="'Yes'"
        :negativeButton="negativeBtn" :default_width="'max-w-xl'" id='vote_modal'>
        <div class="w-full px-5 pb-4 flex flex-col text-xl justify-center text-center items-center">
            {{ this.modal_message }}
        </div>
    </ModalControl>

    <ModalControl v-show="cancel_modal" v-bind:display="cancel_modal" question z_value="z-50"
        @positiveClick="this.$router.push('election')" @negativeClick="cancel_modal = false" :positiveButton="'Yes'"
        :negativeButton="'No'" :default_width="'max-w-xl'" id='vote_modal'>
        <div class="w-full px-5 pb-4 flex flex-col text-xl justify-center text-center items-center">
            Are you sure you want to cancel? Your votes will be cleared. 
        </div>
    </ModalControl>

    <ModalControl v-show="ballot_modal" v-bind:display="ballot_modal" closable @closed="ballot_modal = false"
        @positiveClick="confirmVote()" :disable_button="!isVotingComplete" :positiveButton="'Submit'"
        z_value="z-50" :default_width="'max-w-[95%] lg:max-w-[60%]'" id='vote_modal'>
        <div class="w-full px-5 pt-2 pb-6 flex flex-col text-xl">
            <BallotControl @bod="goToStep(0); ballot_modal = false;" @audit="goToStep(1); ballot_modal = false;"
                @elecom="goToStep(2); ballot_modal = false;" />

        </div>
    </ModalControl>
</template>

<script>
import { defineComponent } from 'vue';
import Loading from '@/components/controls/LoadingControl.vue';
import ModalControl from '@/components/controls/ModalControl.vue';
import BoardOfDirectorsView from './BoardOfDirectorsView.vue';
import AuditCommView from './AuditCommView.vue';
import ElectionCommView from './ElectionCommView.vue';
import BallotControl from './BallotControl.vue';
import User from "@/services/User";
import Election from '@/services/Election';
import ButtonControl from '@/components/controls/ButtonControl.vue';

export default defineComponent({
    components: {
        Loading,
        ModalControl,
        BoardOfDirectorsView,
        AuditCommView,
        ElectionCommView,
        ButtonControl,
        BallotControl
    },
    inject: ['setLoading'],
    data() {
        return {
            negativeBtn: null,
            confirm_modal: false,
            cancel_modal: false,
            ballot_modal: false,
            currentStep: 0,
            stepCompleted: [false, false, false],
            loading: false,
            show_message_modal: false,
            modal_message: '',
            success: false,
            warning: false,
            error: false,
            question: false,
            expired: false,
            category: 'Board of Directors',
            bodOfficerCount: 0,
            bodEpCount: 0,
            bodCivilianCount: 0,
            auditCount: 0,
            elecCommCount: 0
        }
    },
    computed: {
        isLastStep() {
            return this.currentStep === 2;
        },
        categoryName() {
            const categories = [
                'Board of Directors',
                'Audit Committee',
                'Election Committee'
            ];

            return categories[this.currentStep] || '';
        },
        isVotingComplete() {
            return this.stepCompleted.every(step => step === true);
        }
    },
    watch: {
        currentStep: {
            handler() {
                this.updateCounters();
            }
        },
        '$store.state.selectedVotes': {
            handler() {
                this.updateCounters();
            },
            deep: true
        }
    },
    mounted() {
        let that = this;
        const state = this.$store.state;
        that.account_number = state.credentials.account_no;
        that.full_name = state.credentials.name;
        that.gender = state.credentials.gender;
        that.Astatus = state.credentials.status;
        that.Membership = state.credentials.membership_type;
        that.Member_since = state.credentials.membership_date;
        that.email = state.credentials.email;
        that.mobile = state.credentials.mobile;
        that.tin = state.credentials.tin;
        that.age = state.credentials.age;
        that.birthdate = state.credentials.birthdate;
        that.serial = state.credentials.serial_no == null ? '??????' : state.credentials.serial_no;
        that.username = state.credentials.username;
        that.registered = state.credentials.registered_date;
        that.qr = state.credentials.qr;
        that.currentTin = state.credentials.tin;


        const rawRegisteredDate = state.credentials.registered_date;
        if (rawRegisteredDate) {
            const parts = rawRegisteredDate.split('-');
            that.registered = `${parts[1]}/${parts[2]}/${parts[0]}`;
        }

        const rawBirthdate = state.credentials.birthdate;
        if (rawBirthdate) {
            const parts = rawBirthdate.split('-');
            that.birthdate = `${parts[1]}/${parts[2]}/${parts[0]}`;
        }

        if (!state.credentials.username) {
            this.getUserInfo();
        } else {
            this.checkUserFlow();
        }

    },
    methods: {
        updateCounters() {
            const bod = this.$store.state.gaCandidates?.bod || [];
            const selectedBod = this.$store.state.selectedVotes.bod || [];

            this.bodOfficerCount = selectedBod.filter(code => {
                const candidate = bod.find(c => c.code === code);
                return candidate && candidate.type === 'OFFICER';
            }).length;

            this.bodEpCount = selectedBod.filter(code => {
                const candidate = bod.find(c => c.code === code);
                return candidate && candidate.type === 'ENLISTED PERSONNEL';
            }).length;

            this.bodCivilianCount = selectedBod.filter(code => {
                const candidate = bod.find(c => c.code === code);
                return candidate && candidate.type === 'CIVILIAN';
            }).length;

            this.auditCount = this.$store.state.selectedVotes.audit?.length || 0;
            this.elecCommCount = this.$store.state.selectedVotes.elecom?.length || 0;
        },
        goToStep(step) {
            this.currentStep = step;
        },
        showBallot() {
            this.ballot_modal = true;
            this.success = false;
            this.error = false;
            this.warning = false;
            this.question = false;
        },
        confirmVote() {
            this.confirm_modal = true;
            this.modal_message = "Are you sure you want to submit your votes?";
            this.question = true;
            this.error = false;
            this.success = false;
            this.warning = false;
            this.expired = false;
            this.ballot_modal = false;
            this.negativeBtn = "Cancel";
        },
        nextStep() {
            if (this.currentStep < 2 && this.stepCompleted[this.currentStep]) {
                this.currentStep++;
            }
        },
        prevStep() {
            if (this.currentStep > 0) {
                this.currentStep--;
            }
        },
        proceedVoting() {
            if (!this.stepCompleted[this.currentStep]) return;

            this.success = true;
            this.modal_message = 'Your votes have been successfully recorded.';
            this.show_message_modal = true;
            this.negativeBtn = null;
        },
        handlePositiveClick() {
            if (this.expired) {
                this.closed();
            } else {
                this.show_message_modal = false;
            } 
        },
        submitVote() {
            this.confirm_modal = false;
            this.setLoading(true);
            const arrayVotes = [
                ...this.$store.state.selectedVotes.bod,
                ...this.$store.state.selectedVotes.audit,
                ...this.$store.state.selectedVotes.elecom
            ];

            const stringVotes = JSON.stringify(arrayVotes);

            Election.submitVotes(this.$cookies.get('user_session').hash, this.$store.state.start_vote.voter_key, this.$store.state.start_vote.ballot_no, stringVotes, this.$store.state.election_otp.uuid)
                .then((response) => {
                    this.$store.state.submit_votes = response.data.data;
                    this.$store.state.submitted = response.data.timestamp;
                    this.$store.state.gaUser.has_participated = true;
                    this.$router.push('/summary-of-votes');
                    this.setLoading(false);
                }).catch((error) => {
                    this.error = true;
                    this.success = false,
                        this.warning = false,
                        this.question = false;
                    this.setLoading(false);
                    this.show_message_modal = true;
                    this.negativeBtn = null;
                    this.modal_message = error.response.data.message;
                    if (error.response.status == 403) {
                        this.expired = true
                        this.modal_message = "Your session has expired. Please log in again.";
                        this.$store.state.logged = false;
                    }
                });

        },
        handleNegativeClick() {
            if (this.expired) {
                this.closed();
            } else {
                this.closed_modal();
            }
        },
        closed() {
            let that = this;

            that.$cookies.remove('user');
            that.$cookies.remove('user_session');
            that.$router.push('/');
            that.show_message_modal = false;
            that.negativeBtn = null;
        },
        checkUserFlow() {
            const that = this;
            const state = that.$store.state;
            const noContact = !state.credentials.mobile || !state.credentials.email;
            const config = state.credentials.config;
            const temporaryPIN = state.credentials.pin_update;
            const isValidated = that.$cookies.get('validated');
            console.log('candidates: ', state.gaCandidates);

            if (
                !state.gaCandidates ||
                !state.gaCandidates.bod ||
                state.gaCandidates.bod.length === 0
            ) {
                this.$router.push('/election');
                return;
            }

            if (state.credentials.deactivated) {
                this.$router.push('/user/settings');
                return;
            }

            if (noContact) {
                state.credentials.noContact = noContact;
                this.show_update = true;
                return;
            }

            if (state.credentials.enrolled_pin) {
                const hasValidConfig = config && config.status;
                const noContact = state.credentials.noContact;
                state.credentials.enrolled_pin = false;

                if (noContact) {
                    that.show_update = false;
                    that.show_pin_modal = false;
                    that.show_otp_modal = false;
                    that.$cookies.set('validated', true);
                } else {
                    if (hasValidConfig) {
                        that.requestOTP();
                    } else {
                        that.show_update = false;
                        that.show_pin_modal = false;
                        that.show_otp_modal = false;
                        that.$cookies.set('validated', true);
                    }
                }
                return;
            }


            if (!isValidated) {
                if (state.credentials.has_pin) {
                    this.show_pin_modal = true;
                } else {
                    this.$router.push('/user/settings');
                }
            }

            if (temporaryPIN) {
                this.$router.push('/user/settings');
                state.credentials.edit_temporary = true;
                return;
            }

            const missingInfo = !state.credentials.mobile || !state.credentials.email ||
                !state.credentials.tin || !state.credentials.birthdate;

            if (missingInfo && !that.$cookies.get('skipped')) {
                this.show_update = true;
            }
        },
        getUserInfo() {
            let that = this;
            const cookie = that.$cookies;
            const store = that.$store;
            let state = store.state;
            that.setLoading(true);

            User.recoverSession(cookie.get('user_session').hash).then(function (response) {
                let data = response.data.data;
                state.logged = true;
                state.credentials.first_name = data.info.first_name;
                state.credentials.last_name = data.info.last_name;
                state.credentials.middle_name = data.info.middle_name;
                state.credentials.regular = data.info.regular;
                state.credentials.express = data.express;
                state.credentials.pso_enroll = data.pso_enroll;
                state.credentials.pin_update = data.pin_update;
                state.credentials.membership_date = data.info.membership_date || null;
                state.credentials.status = data.status || null;
                state.credentials.account_no = data.info.account_number;
                state.gaUser = data.ga;
                state.credentials.email = data.info.email;
                state.credentials.gender = data.info.gender;
                state.credentials.birthdate = data.info.date_of_birth;
                state.credentials.age = data.info.age;
                state.credentials.membership_type = data.info.membership_type;
                state.credentials.registered_date = data.info.registered;
                state.credentials.key = data.key;
                state.credentials.mobile = data.info.mobile;
                state.credentials.name = data.info.first_name + " " + data.info.last_name + (data.info.suffix ? " " + data.info.suffix : "");
                state.credentials.suffix = data.info.suffix ?? '';
                state.credentials.qr = data.qr;
                state.credentials.uuid = data.uuid;
                state.credentials.serial_no = data.info.serial_number;
                state.credentials.timestamp = response.timestamp;
                state.credentials.username = data.info.username;
                state.credentials.hash = data.hash;
                state.credentials.has_pin = data.has_pin;
                state.credentials.deactivated = data.deactivated;
                state.credentials.tin = data.info.tin;
                state.balances = data.balances;
                const type2Config = data.config.find(item => item.type === 2);
                if (type2Config) {
                    state.credentials.config = { status: type2Config.status };
                } else {
                    state.credentials.config = null;
                }
                that.account_number = state.credentials.account_no;
                that.full_name = state.credentials.name;
                that.gender = state.credentials.gender;
                that.Astatus = state.credentials.status;
                that.Membership = state.credentials.membership_type;
                that.Member_since = state.credentials.membership_date;
                that.email = state.credentials.email;
                that.mobile = state.credentials.mobile;
                that.tin = state.credentials.tin;
                that.age = state.credentials.age;
                that.birthdate = state.credentials.birthdate;
                that.serial = state.credentials.serial_no == null ? '??????' : state.credentials.serial_no;
                that.username = state.credentials.username;
                that.registered = state.credentials.registered_date;
                that.qr = data.qr;
                that.currentTin = state.credentials.tin;
                that.express = data.express;
                that.deactivated = data.deactivated;
                const rawRegisteredDate = state.credentials.registered_date;
                if (rawRegisteredDate) {
                    const parts = rawRegisteredDate.split('-');
                    that.registered = `${parts[1]}/${parts[2]}/${parts[0]}`;
                }

                const rawBirthdate = state.credentials.birthdate;
                if (rawBirthdate) {
                    const parts = rawBirthdate.split('-');
                    that.birthdate = `${parts[1]}/${parts[2]}/${parts[0]}`;
                }

                that.checkUserFlow();
                that.setLoading(false);

            }).catch(function (error) {
                that.error = true;
                that.setLoading(false);
                that.show_message_modal = true;
                that.negativeBtn = null;
                that.modal_message = error.response.data.message;
                if (error.response.status == 403) {
                    that.expired = true
                    that.modal_message = "Your session has expired. Please log in again.";
                    that.$store.state.logged = false;
                }
            });
        }
    },
    watcher: {
        timerCount: {
            handler(value) {
                if (value > 0 && this.timerEnabled) {
                    this.show_resend_otp = false;
                    setTimeout(() => {
                        this.timerCount = this.timerCount - 1;
                        // console.log(this.timerCount);
                    }, 1000);
                } else {
                    this.show_resend_otp = true;
                    this.timerEnabled = false; // run your function here
                }
            },
            immediate: true
        },
    }
})
</script>
<style scoped>
.max-width-back {
    max-width: 50px;
}
</style>
